export default __webpack_public_path__ + "static/6587-b278f5da351716b5dc07d765cd258649.jpg";